/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Tire Icon component.
 */
export const TireIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='20.0029' cy='19.9949' r='8.87087' transform='rotate(119.682 20.0029 19.9949)' stroke={iconColor} strokeWidth='1.5' />
      <circle cx='20.0003' cy='20.0002' r='14.8464' transform='rotate(89.6816 20.0003 20.0002)' stroke={iconColor} strokeWidth='1.5' />
      <path d='M29.1681 21.3688L25.7173 20.063C24.8543 19.7364 23.8826 19.8955 23.1689 20.4803C22.5981 20.9481 22.2544 21.6494 22.2256 22.3869C22.1916 23.2601 22.5918 24.1073 23.2952 24.6258L26.2826 26.828' stroke={iconColor} strokeWidth='1.5' />
      <path d='M14.1622 12.732L17.076 15.0833C17.7956 15.664 18.1477 16.5867 17.9977 17.4993C17.8786 18.2245 17.4545 18.864 16.8329 19.256L16.7956 19.2795C16.0619 19.7421 15.1491 19.8191 14.3483 19.486L11.0533 18.1151' stroke={iconColor} strokeWidth='1.5' />
      <path d='M18.4567 29.1957L19.9377 25.2681C20.2637 24.4034 20.101 23.4304 19.5114 22.7188C19.0418 22.1521 18.352 21.8136 17.6164 21.789L17.5802 21.7878C16.7104 21.7586 15.8816 22.1578 15.3622 22.8561L12.9934 26.0409' stroke={iconColor} strokeWidth='1.5' />
      <path d='M21.871 10.8012L20.5708 13.8501C20.2063 14.7047 20.3363 15.6901 20.91 16.421C21.3597 16.9939 22.0332 17.3468 22.7603 17.3904L22.8116 17.3935C23.6788 17.4455 24.5169 17.0708 25.0563 16.3898L27.0945 13.8169' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default TireIcon;
